export default __webpack_public_path__ + "static/media/mattis-min.cc310eab.png";